import { FC, useState } from "react"
import { Box, Container, Stack, Tab, Tabs, Typography } from "@mui/material"
import { MailingForm } from "../components/mailing/manual/mailingForm"
import { MailingCsvForm } from "../components/mailing/csv/csvForm"
import { useTitle } from "@/core/hooks"

interface IProps {}

export const CreateMailingPage: FC<IProps> = (props) => {
  const [tab, setTab] = useState(1)
  useTitle(`PR Telegram - Рассылки`)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue)
  }
  return (
    <Container maxWidth={"xl"}>
      <Stack spacing={3}>
        <Typography variant="h5">Создание новой рассылки</Typography>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tab}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label={"CSV таблица"} tabIndex={0} />
            <Tab label={"Форма"} tabIndex={1} />
          </Tabs>
        </Box>
        <Box sx={{ display: tab === 0 ? "block" : "none" }}>
          <MailingCsvForm />
        </Box>
        <Box sx={{ display: tab === 1 ? "block" : "none" }}>
          <MailingForm />
        </Box>
      </Stack>
    </Container>
  )
}
